// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"e01eacfb","787":"13fb48c9"}[chunkId] + ".chunk.js";
};